import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit   {

  constructor() { }

  ngOnInit(): void {}

  onSealClick(){
      window.open('https://www.rapidscansecure.com/siteseal/Verify.aspx?code=133,814735923C2CE05C4617632A722F9D35A49CA79A', 'Verification', 'location=no, toolbar=no, resizable=no, scrollbars=yes, directories=no, status=no,top=100,left=100, width=960, height=526');
      return false;
  }

}
